import { Component, Inject } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { PromoPartnerFamily } from 'src/app/assabil-sales/models/entities/promo-partner-family.entity';
import { PromoService } from 'src/app/assabil-sales/services/pomo-service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GenericLovComponent } from 'src/app/tools/abstract-classes/generic-lov.component';

@Component({
    selector: 'promo-partner-family-lov',
    templateUrl: './promo-partner-family-lov.component.html',
    styleUrls: ['./promo-partner-family-lov.component.scss']
})

export class PromoPartnerFamilyLovComponent extends GenericLovComponent {

    code            : string;
    name            : string;

    columns = [
      { prop: 'promoPartnerFamilyCode',      name: 'Code'                       },
      { prop: 'promoProductFamilyCode',      name: 'Code',   insertOnly :  true },
      { prop: 'name',                        name: 'Nom'                        },
      { prop: 'rank',                        name: 'Rang',   type : 'number'    },
    ]


    promoPartnerFamilys   : PromoPartnerFamily[] = [];
    returnList            : boolean = false;

    constructor(
      public dialogRef: MatDialogRef<PromoPartnerFamilyLovComponent>,  @Inject(MAT_DIALOG_DATA) public data: any,
      protected promoService  : PromoService,
      protected toastr        : ToastrService,
      protected router        : Router,
      protected location      : Location) {
        super();
        if (data) {
          this.promoPartnerFamilys  = data.promoPartnerFamilys;
          this.returnList           = data.returnList; 
        }
    }


  //----------------------------------------------------------------------------------------------------------------
    loadData() {
      this.promoService.promoPartnerFamiliesGet(this.code, this.name).then(result => {
        this.promoPartnerFamilys = result;
      });
    }
   //----------------------------------------------------------------------------------------------------------------
    

  //----------------------------------------------------------------------------------------------------------------   
    closeModal(promoPartnerFamily : PromoPartnerFamily){
      if (this.returnList) {
        let result = {promoPartnerFamilys : null, promoPartnerFamily : null};
        result.promoPartnerFamily  = promoPartnerFamily;
        result.promoPartnerFamilys = this.promoPartnerFamilys;
        this.dialogRef.close(result);
      } else {
        this.dialogRef.close(promoPartnerFamily);
      }
    }
//----------------------------------------------------------------------------------------------------------------   
  
}
